




































































































































































































































import { Component, Prop, PropSync, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'
import { InputCode } from '@/components/molecules/InputCode'
import { InputCodeMultiple } from '@/components/molecules/InputCodeMultiple'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { InputCollectionNo } from '@/components/molecules/InputCollectionNo'
import {
  dataStore,
  systemCodeStore,
  systemParameterStore
} from '@/utils/store-accessor'
import { ReserveMethod } from '@/types'

export interface InputReserveItem {
  reserveMethod: {
    input: ReserveMethod
    errorMessage: string
  }
  reserveSpecifyBranch: {
    input: SystemCode[]
    errorMessage: string
  }
  // 回送依頼ダイアログで使用する
  // 資料の選択で取得したidを渡す
  specifyCollectionId: {
    input: number
  }
  specifyCollectionNo: {
    input: string
    errorMessage: string
  }
  reserveBranch: {
    input: SystemCode
    errorMessage: string
  }
  reservePlace: {
    input: SystemCode
    errorMessage: string
  }
  forwardingBranch: {
    input: SystemCode
    errorMessage: string
  }
  reserveRegistrationDate: {
    input: string
    errorMessage: string
  }
  preferredDate: {
    input: string
    errorMessage: string
  }
  reserveExpiration: {
    input: string
    errorMessage: string
  }
  noticeAllowed: {
    input: boolean
    errorMessage: string
  }
  contactMethod: {
    input: SystemCode
    errorMessage: string
  }
  memoCode: {
    input: SystemCode
    errorMessage: string
  }
  memo: {
    input: string
    code: string
    errorMessage: string
  }
  forwardingPlaceCode: {
    input: SystemCode
    errorMessage: string
  }
  requestReserve: {
    input: boolean
    errorMessage: string
  }
}

export const defaultInputReserveItem = (): InputReserveItem => ({
  reserveMethod: {
    input: systemParameterStore.reserveMethodPresetValue,
    errorMessage: ''
  },
  reserveSpecifyBranch: {
    input: systemParameterStore.defaultReserveSpecifyBranchCodes,
    errorMessage: ''
  },
  specifyCollectionId: {
    input: 0
  },
  specifyCollectionNo: {
    input: '',
    errorMessage: ''
  },
  reserveBranch: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  reservePlace: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  forwardingBranch: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  reserveRegistrationDate: {
    input: '',
    errorMessage: ''
  },
  preferredDate: {
    input: '',
    errorMessage: ''
  },
  reserveExpiration: {
    input: '',
    errorMessage: ''
  },
  noticeAllowed: {
    input: false,
    errorMessage: ''
  },
  contactMethod: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  memoCode: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  memo: {
    input: '',
    code: '',
    errorMessage: ''
  },
  forwardingPlaceCode: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  requestReserve: {
    input: false,
    errorMessage: ''
  }
})

@Component({
  components: {
    InputCollectionNo,
    InputCode,
    InputCodeMultiple,
    InputDatePicker
  }
})
export default class ReserveReserveInfo extends ComponentVue {
  @Prop({
    type: Boolean,
    default: false
  })
  disabledReserveMethod!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabledSpecifyCollectionId!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  hideInputSpecifyCollectionNo!: boolean

  @Prop({
    type: Object,
    default: defaultSystemCode()
  })
  materialFormat!: SystemCode

  @PropSync('input', {
    type: Object,
    required: true
  })
  internalInput!: InputReserveItem

  get displayReserveMethod(): boolean {
    return dataStore.displayModalReserveReserveMethod
  }

  get displayForwardingBranch(): boolean {
    return dataStore.displayModalReserveForwardingBranch
  }

  get displayForwardingPlace(): boolean {
    return dataStore.displayModalReserveForwardingPlace
  }

  get displayReserveContactMethod(): boolean {
    return dataStore.displayModalReserveContactMethod
  }

  get disabledForwardingPlaceCode(): boolean {
    return (
      !this.existsMobileLibraryPlaceCodes(
        this.internalInput.forwardingBranch.input.code
      ) || this.materialFormat.option3 === '0'
    )
  }

  get reserveMethod(): any {
    return ReserveMethod
  }

  @Watch('internalInput.forwardingBranch.input.code')
  onInputMyBranchCode(newVal: string, oldVal: string): void {
    this.internalInput.forwardingBranch.errorMessage = ''
    if (newVal !== oldVal) {
      this.internalInput.forwardingPlaceCode.input = defaultSystemCode()
      this.internalInput.forwardingPlaceCode.errorMessage = ''
    }
  }

  existsMobileLibraryPlaceCodes(branchCode: string): boolean {
    return systemParameterStore.mobileLibraryPlaceCodes(branchCode).length > 0
  }

  exclusionForwardingPlaceCodes(branchCode: string): string[] {
    return systemCodeStore.getPlaceCode
      .filter(placeCode =>
        systemParameterStore
          .mobileLibraryPlaceCodes(branchCode)
          .every(mobilePlaceCode => mobilePlaceCode.code !== placeCode.code)
      )
      .map(systemCode => systemCode.code)
  }

  onInputReserveSpecifyBranch(items: SystemCode[]) {
    this.internalInput.reserveSpecifyBranch.input = items
    this.internalInput.reserveSpecifyBranch.errorMessage = ''
  }

  onInputMemoCode(input: SystemCode) {
    this.internalInput.memoCode.input = input
    this.internalInput.memo.input = input.name
    this.internalInput.memo.errorMessage = ''
  }
}
